import { Component, OnInit, OnDestroy, Input, inject, CUSTOM_ELEMENTS_SCHEMA, ViewChild, AfterViewInit, PLATFORM_ID, Inject, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { CmsService } from 'src/_service/CmsService';
import { FeaturedCardComponent } from '../recipecard/featured-card.component';
import { OrderService } from 'src/_service/OrderService';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sortdirection, TableParameters } from 'src/_model/shared';
import { Flowtype } from 'src/_model/order';
import { RecipeService } from 'src/_service/RecipeService';
import { Recipe } from 'src/_model/recipe';
import { Swiper, SwiperOptions } from 'swiper/types';
import { Button, CmsWeekFavorites } from 'src/_model/storyblock';
import { CmsButtonComponent } from "../cms-button/cms-button.component";
import { FirstDeliveryRecipeweekSelectorComponent } from '../first-delivery-recipeweek-selector/first-delivery-recipeweek-selector.component';

@Component({
    selector: 'app-cms-week-favorites',
    templateUrl: './cms-week-favorites.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
    RouterLink,
    FeaturedCardComponent,
    TranslateModule,
    CmsButtonComponent,
    FirstDeliveryRecipeweekSelectorComponent
]
})
export class CmsWeekFavoritesComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() flowtype: Flowtype = Flowtype.SUBSCRIPTION;
  @Input() block: CmsWeekFavorites;
  @Input() lifestyleid: number;

  @ViewChild('swiperRef') private swiperRef;
  
  private _cmsService = inject(CmsService);
  private _orderService = inject(OrderService);
  private _router = inject(Router);
  private _recipeService = inject(RecipeService);
  
  title: string | SafeHtml = 'De Ekomenu favorieten van deze week:';
  description: string | SafeHtml = '';
  link: string = '';
  linkName: string = '';
  button: Button

  deliverydate: string;
  hasRecipes: boolean = false;
  selectedPersons: { [recipeId: number]: number } = {};

  recipes: Recipe[] = [];
  loading: boolean = false;
  swiper?: Swiper;
  uniqueId: string = `swiper-${Math.random().toString(36).substr(2, 9)}`;
  private readonly MAX_FUTURE_DAYS = 60;
  private readonly DAYS_IN_WEEK = 7;
  private readonly LAST_DAY_OF_WEEK = 6;
  private minAvailableDeliveryDate: string | null = null;
  private unsubscribe = new Subject<void>();
  
  swiperOptions: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    pagination: {
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active'
    },
    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
          clickable: false,
          bulletClass: 'swiper-pagination-bullets hidden'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }
    },
    enabled: true,
    direction: 'horizontal'
  };
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {

    this.title = this._cmsService.render_rt(this.block?.Title); 
    this.description = this._cmsService.get_content(this.block?.Description);
    this.button =  this.block?.CTA? this.block?.CTA[0] : null

    const linkValue = this.block?.Link;
    if (linkValue !== undefined && linkValue !== null && linkValue !== '') {
      if (typeof linkValue === 'string') {
        this.link = linkValue;
      } else if (linkValue?.url) {
        this.link = linkValue.url;
      } else if (linkValue?.href) {
        this.link = linkValue.href;
      } else {
        this.link = String(linkValue);
      }
    }

    this.linkName = this.block?.LinkName;
    
    this._orderService.orderFlowForm.get('deliverydate').valueChanges.pipe(
      takeUntil(this.unsubscribe)
    ).subscribe(res=> {
      this.deliverydate = res;
      this.loadRecipes();
    });

    this.deliverydate = this._orderService.orderFlowForm.get('deliverydate').value;
    this.loadRecipes();
  }
  
  ngAfterViewInit() {
  }
  

  
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    
    if (this.swiper) {
      try {
        this.swiper.destroy(true, true);
      } catch (e) {
        console.warn('Error destroying swiper on component destroy:', e);
      }
    }
  }

  private initSwiper(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    
    if (this.swiper) {
      try {
        this.swiper.destroy(true, true);
        this.swiper = undefined;
      } catch (e) {
        console.warn('Error destroying swiper:', e);
      }
    }
    
    setTimeout(() => {
      if (this.swiperRef && this.swiperRef.nativeElement) {
        const swiperEl = this.swiperRef.nativeElement;
        
        const nav1024 = this.swiperOptions.breakpoints[1024].navigation;
        if (nav1024 && typeof nav1024 === 'object') {
          nav1024.nextEl = `.${this.uniqueId}-next`;
          nav1024.prevEl = `.${this.uniqueId}-prev`;
        }
        
        Object.assign(swiperEl, this.swiperOptions);
        
        swiperEl.initialize();
        this.swiper = swiperEl.swiper;
        this.cdr.detectChanges();
      }
    }, 0);
  }
    
  isExternalLink(link: string): boolean {
    return link.startsWith('http://') || link.startsWith('https://') || link.startsWith('mailto:') || link.startsWith('tel:');
  }
  
  private loadRecipes(): void {
    if (!this.deliverydate) return;
    
    this.loading = true;
    this.recipes = [];
    this.hasRecipes = false;
    
    this._recipeService.getRecipeTableByPeriod(new TableParameters(1, 7, "id", Sortdirection.DESC), this.deliverydate, this.deliverydate)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (result: any) => {
          this.loading = false;
          if (result && result.content) {
            this.recipes = result.content;
            this.hasRecipes = this.recipes.length > 0;
            
            if (this.hasRecipes) {
              this.initSwiper();
            }
          }
        },
        error: (error) => {
          console.error('Error loading recipes:', error);
          this.loading = false;
          this.hasRecipes = false;
        }
      });
  }

  onRecipeSelected(selected: boolean, recipe: any): void {
    if (selected) {
      const persons = this.selectedPersons[recipe.id] || 2;
      this.addRecipeToCart(recipe, persons);
    }
  }

  onPersonsChange(persons: number, recipeId: number): void {
    this.selectedPersons[recipeId] = persons;
  }

  private addRecipeToCart(recipe: any, persons: number): void {
    const added = this._orderService.createNewOrderline(null, null, recipe, persons ? persons : persons, 1, false, true, false, false, this.flowtype);
    this._router.navigate(['/recipefirst']);
  }

  canChangeWeek(): Promise<boolean>{
    const orderlines = this._orderService.getFlowOrderlines(this.flowtype);
    for (let i = orderlines.length - 1; i >= 0; i--) {
      const orderline = orderlines.at(i).value;
      if (orderline.recipeid) {
         this._orderService.removeOrderlineByIndex(i, this.flowtype);
      }
    }
    return new Promise<boolean>(resolve => resolve(true))
  }
}
